import { getGifUrl } from "../lib/utils";

const GifEmbed = (props) => {
  const gifUrl = getGifUrl(props.text);

  return (
    gifUrl && <img src={gifUrl} alt="GIF" />
  );
}

export default GifEmbed;
